import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { RestService } from '../../service/api/rest.service';
import { SystemUsers } from './systemUsers.model';

@Injectable({providedIn: 'root'})
export class SystemUsersEntityService extends EntityCollectionServiceBase<SystemUsers>
{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private rest: RestService)
    {
        super('SystemUsers', serviceElementsFactory);
    }
}
